


































































import moment from "moment";
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class MyDateTimePicker extends Vue {
  @Prop({ default: "" }) id?: string;
  @Prop({ default: "" }) label?: string;
  @Prop({ default: "" }) value: string;
  @Prop({ default: "" }) rules: string;
  @Prop({ default: null }) min: string;
  @Prop({ default: null }) max: string;
  @Prop({ default: null }) invalidMsg: string;
  @Prop({default : false}) disabled: boolean;
  @Prop({ default: () => ({ left: false, readonly: false }) }) options?: any;

  show = false;
  myTime = "";
  formattedDate = "";

  get identifier() {
    return this.id ? this.id : this.lodash.uniqueId(`datetimepicker-${new Date().getTime()}-`);
  }

  get myDate() {
    if (this.value) {
      this.formattedDate = moment(this.value).format("DD-MM-YYYY HH:mm");
      this.myTime = moment(this.value).format("HH:mm");
    }
    return this.value;
  }

  set myDate(val) {
    if (val) {
      this.formattedDate = moment(val).format("DD-MM-YYYY") + " " + this.myTime;
      this.$emit("input", val);
    }
  }

  @Watch("myTime")
  onMyTimeWatch() {
    this.formattedDate =
      moment(this.myDate).format("DD-MM-YYYY") + " " + this.myTime;
    this.$emit(
      "input",
      moment(this.formattedDate, "DD-MM-YYYY HH:mm").format("YYYY-MM-DD HH:mm")
    );
  }

  @Watch("formattedDate")
  onFormattedDateWatch() {
    if (!this.formattedDate) {
      this.$emit("input", this.formattedDate);
    }
  }

  changeDate(val) {
    if(val) {
      this.value = moment(val, "DD-MM-YYYY HH:mm", true).isValid() ?  moment(val, "DD-MM-YYYY HH:mm").format("YYYY-MM-DD HH:mm") : moment().format("YYYY-MM-DD HH:mm");
      this.myDate = this.value;
    } else {
      this.value = val;
      this.myDate = val;
    }
  }
}
